<script>
import { BPopover } from "bootstrap-vue";

export default {
  extends: BPopover
};
</script>